<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/cloud-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">传统企业销售渠道的弊端</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud01.png" alt="">
          新型渠道拓展难
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud02.png" alt="">
          整体盈利能力下降
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud03.png" alt="">
          政策无法有效传递
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud04.png" alt="">
          上下游信息不对称
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">云采购平台,帮助企业实现<br>销售全流程协同</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud05.png" alt="">
          <span class="title">销售商城</span>
          <span class="sub-title">全天全时 订货在线</span>
          <div class="text">提供pc、app、小程序等多端的数字化采购商城，实现业务从线下走向线上，节约采购成本</div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud06.png" alt="">
          <span class="title">销售管家</span>
          <span class="sub-title">贴身客户 身边服务</span>
          <div class="text">合同在线、代客下单、采购议价，自动拆单、返利政策等覆盖从售前到售后的实用功能，让采购交易更简单</div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud07.png" alt="">
          <span class="title">销售参谋</span>
          <span class="sub-title">数据驱动 销售决策</span>
          <div class="text">覆盖经营过程中的多角度数据分析，让数据去驱动业务的开展，支撑精准营销及数据化运营</div>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cloud08.png" alt="">
          <span class="title">销售链接</span>
          <span class="sub-title">渠道无界 业务连接</span>
          <div class="text">通过云采购商城，可以和线下更多的供应链厂家合作，满足采购商多种商品诉求</div>
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">让传统业务融入互联网，<br>实现B2b业务全流程监控</div>
        <div class="sub-title">为助力供应商、品牌商打造云采购商城，整合<br>行业上下游资源，有效管理经销商及终端销售者</div>
      </div>
      <img class="image01" src="@/assets/Mobile/images/solution/cloud09.png" alt="">
    </div>
    <div class="block-comnon-01">
      <div class="content">
        <div class="item">
          <span class="title">随时随地下单，流程全在线</span>
          <div class="line" />
          <span class="text">客户在采购商城随时随地自主下单采购，商品流、订单流、物流、资金流全在线，还能够根据行业，智能运营推荐优质商品，销售成本减少，销售更高效</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/cloud10.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-comnon-01">
      <div class="content">
        <div class="item">
          <span class="title">不同等级不同价格，不同区域不同价格</span>
          <div class="line" />
          <span class="text">支持等级价、区域价、阶梯价等不同定价策略，还可以设置相应的购买权限、起订量，限定量，多维护支持采购业务</span>
          <div class="image-wapper">
            <img class="image02" src="@/assets/Mobile/images/solution/cloud11.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-comnon-01">
      <div class="content">
        <div class="item">
          <span class="title">智能推荐服务，促进交易高效转化</span>
          <div class="line" />
          <span class="text">借力数据模型服务，会根据采购方多维度情况，为其推荐潜在兴趣商品，推荐优质货源供应商，促进商品成交</span>
          <div class="image-wapper">
            <img class="image03" src="@/assets/Mobile/images/solution/cloud12.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">建立全渠道销售的移动电商新模式</div>
      </div>
      <img src="@/assets/Mobile/images/solution/cloud13.png" alt="">
    </div>
    <IndustrySolution />
    <Case title="云采购" />

    <ContactForm info-sources="云采购" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.CloudPurchase,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    justify-content: space-evenly;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      line-height: 19px;
      font-size: 8px;
      font-weight: 500;
      color: #595961;
    }
    img {
      width: 54px;
    }
  }
}
.block02 {
  overflow: hidden;
  .content {
    margin: 21px 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-top: 42px;
      margin-bottom: 7px;
      width: 162px;
      height: 150px;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px 0px rgba(221, 221, 221, 0.5);
      border-radius: 3px;
      display: flex;
      flex-direction: column;
      position: relative;
      img {
        position: absolute;
        width: 83px;
        height: 83px;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .title {
        margin-top: 45px;
        font-size: 14px;
        font-weight: 500;
        color: #4DB0FF;
        line-height: 29px;
      }
      .sub-title {
        font-size: 10px;
        font-weight: 400;
        color: #595961;
        line-height: 29px;
      }
      .text {
        width: 142px;
        font-size: 8px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 14px;
        text-align: left;
        margin: 0 auto;
      }
    }
  }
}
.block-comnon-01 {
  overflow: hidden;
  .content {
    margin-top: 33px;
    padding: 0 16px;
    .item {
      text-align: left;
      margin-bottom: 38px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      .title {
        font-size: 19px;
        font-weight: 600;
        color: #595961;
        line-height: 27px;
      }
      .line {
        margin: 15px 0;
        width: 28px;
        height: 4px;
        background: #3986FF;
      }
      .text {
        font-size: 14px;
        font-weight: 300;
        color: #333333;
        line-height: 22px;
      }
      .image-wapper {
        padding-top: 38px;
        text-align: center;
      }
      .image01 {
        width: 262px;
      }
      .image02 {
        width: 240px;
      }
      .image03 {
        width: 226px;
      }
    }
  }
}
.block03 {
  background-color: #FAFAFA;
  .image01 {
    width: 342px;
    margin: 16px 0 21px 0;
  }
}
.block04 {
  background-color: #FAFAFA;
  img {
    width: 329px;
    margin-top: 21px;
  }
}
</style>
